<script>
import LandingBanner from '@rei/banner-component';
import LandingImageComponent from '@rei/landing-image-component';

export default {
  name: 'BrandBanner',
  components: {
    LandingBanner,
    LandingImageComponent,
  },
  props: {
    brandLogo: {
      type: Object,
      required: true,
      default: () => {},
    },
    author: {
      type: String,
      required: true,
      default: '',
    },
    quote: {
      type: String,
      required: true,
      default: '',
    },
    backgroundImage: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
};
</script>

<template>
  <div
    class="greenlight-banner"
    data-ui="greenlight-banner"
  >
    <landing-banner
      :content-position="{ xs: 'left center' }"
      banner-height="thin"
    >
      <template
        #background
      >
        <landing-image-component
          v-bind="backgroundImage"
          class="greenlight-banner__background"
        />
      </template>
      <template
        #content
      >
        <div
          class="greenlight-banner__content"
        >
          <figure class="greenlight-banner__content-text">
            <blockquote
              class="greenlight-banner__quote"
              v-html="quote"
            />
            <figcaption
              class="greenlight-banner__author"
              v-html="author"
            />
          </figure>
          <image-component
            v-bind="brandLogo"
            class="greenlight-banner__brand-logo"
          />
        </div>
      </template>
    </landing-banner>
    <div class="greenlight-banner__mobile-content">
      <figure class="greenlight-banner__content-text">
        <blockquote
          class="greenlight-banner__quote"
          v-html="quote"
        />
        <figcaption
          class="greenlight-banner__author"
          v-html="author"
        />
      </figure>
    </div>
  </div>
</template>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.greenlight-banner {
  padding: 0 $cdr-space-one-x;

  @include cdr-sm-mq-up {
    padding: 0;
  }

  .banner {
    border-radius: 8px;
    overflow: hidden;

    @include cdr-sm-mq-up {
      border-radius: 0;
    }
  }

  &__background::after {
    content: '';
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2));
    display: block;
    position: absolute;
    inset: 0;

     @include cdr-sm-mq-up {
      background: linear-gradient(93.02deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 62.82%);
    }
  }
  &__content {
    @include cdr-container;

    @include cdr-sm-mq-up {
      padding: 0 9rem;
    }
  }

  &__mobile-content {
    padding: 5.6rem 0 6.4rem;
    text-align: center;

    .greenlight-banner__content-text {
      display: inline-block;
    }

    @include cdr-sm-mq-up {
      display: none;
    }
  }

  &__content-text {
    margin: 0;
    max-width: 500px;
    display: none;

    @include cdr-sm-mq-up {
      display: block;
    }
  }

  &__author,
  &__quote {
    display: block;

    @include cdr-sm-mq-up {
      color: $cdr-color-text-inverse;
    }
  }

  &__quote {
    @include cdr-text-utility-serif-600;
    margin: 0 0 $cdr-space-one-x;
    padding: 0;
    quotes: "“" "”" "‘" "’";

    &::before {
      content: open-quote;
    }
    &::after {
      content: close-quote;
    }
  }

  &__author {
    @include cdr-text-utility-sans-100;
    margin-bottom: $cdr-space-one-x;
  }

  &__brand-logo {
    display: block;
    max-width: 200px;
    margin: 0 auto;

    @include cdr-sm-mq-up {
      margin: 0;
    }
  }
}
</style>
